import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-background-50 text-secondary-500 rounded-lg text-sm font-bold">
                区
              </span>
              <span className="font-heading text-lg font-semibold text-background-50 whitespace-nowrap">
                一区二区导航
              </span>
            </Link>
            <p className="text-sm text-background-50/70 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-background-50/70 hover:text-background-50 transition-colors whitespace-nowrap">
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-background-50">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-mail-line text-sm"></i>
                {siteInfo.contact.email}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-phone-line text-sm"></i>
                {siteInfo.contact.phone}
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/70">
                <i className="ri-map-pin-line text-sm"></i>
                {siteInfo.contact.address}
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/15 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-50/60">
            &copy; {new Date().getFullYear()} 一区二区导航 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors whitespace-nowrap">
              使用条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}